import * as types from '../../action-types';
import {addConsumer as initialState } from "../../initialState";

const addConsumer = (state=initialState, action) => {
  switch (action.type) {
    case types.ADD_CONSUMER_START:
      return {
        ...state,
        isLoading: true
      };
    case types.ADD_CONSUMER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.ADD_CONSUMER_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.ADD_CONSUMER_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default addConsumer;
